import { Image } from '@/types/image'
import { v4 as uuidv4 } from 'uuid'
import { getPrefixedStorageURL } from './getPrefixedStorageURL'

export const mapImageObject = (images: string | Image): Image[] => {
  // If no images, return empty array
  if (!images || images === 'null') return []

  if (Array.isArray(images)) {
    // Loop through the images and set the object values
    return images.map((image: Image | string): Image => {
      // If the image is a string, convert it to an object
      if (typeof image !== 'string') {
        return {
          uuid: image.uuid || uuidv4(),
          path: getPrefixedStorageURL(
            image.url ?? image.path ?? image.preview ?? ''
          ),
          pathImgkit: getPrefixedStorageURL(
            image.url ?? image.path ?? image.preview ?? 'imgkit' ?? ''
          ),
          description: image.description ?? '',
        }
      }
      return {
        uuid: uuidv4(),
        path: getPrefixedStorageURL(image) ?? '',
        pathImgkit: getPrefixedStorageURL(image, 'imgkit') ?? '',
        description: '',
      }
    })
  }

  return []
}

// Take legacy image strings and convert them to valid image objects
export const formatProjectImages = <I>(images: string): I[] | null => {
  // Convert the string to an array
  if (typeof images === 'string') {
    return mapImageObject(JSON.parse(JSON.parse(images))) as I[]
  }
  return mapImageObject(images) as I[]
}
